<template>
  <div>
    <el-row style="padding-bottom: 10px" @keyup.enter.native="search">
      <el-col :span="24" class="search-box">
        <span
          ><label>门店：</label>
          <DropdownSelect
            v-model="shopId"
            :action="api.dealer.shop.all"
            textField="name"
            valueField="id"
          ></DropdownSelect>
        </span>
        <span> <el-button type="primary" @click="search">搜索</el-button></span>
      </el-col>
    </el-row>
    <page-table
      :data-api="this.api.dealer.recharge"
      :viewable="false"
      keyField="id"
      :deletable="false"
      :editable="false"
    >
      <el-table-column prop="id" label="编号" width="60"></el-table-column>
      <el-table-column prop="quantity" label="充值数量"></el-table-column>
      <el-table-column prop="shopName" label="门店"></el-table-column>
      <el-table-column prop="typeName" label="设备类型"></el-table-column>
      <el-table-column v-if="!isMobile()"
        prop="status"
        label="状态"
        :formatter="statusFormatter"
      ></el-table-column>
      <el-table-column v-if="!isMobile()"
        prop="payType"
        label="支付类型"
        :formatter="payTypeFormatter"
      ></el-table-column>
      <el-table-column
        prop="created"
        label="添加时间"
        :formatter="dateFormatter"
      ></el-table-column>
    </page-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      shopId: null,
    };
  },
  created: function () {
    let that = this;
    let query = that.getQuery();
    that.shopId = query.shopId ? parseInt(query.shopId) : null;
  },
  methods: {
    dateFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return cellValue;
      }
      return this.dateFormat("yyyy-mm-dd HH:MM:SS", new Date(cellValue));
    },
    statusFormatter(row, column, cellValue, index) {
      if (1 == cellValue) {
        return "待支付";
      } else if (2 == cellValue) {
        return "交易成功";
      } else if (3 == cellValue) {
        return "订单关闭";
      }
      return cellValue;
    },
    payTypeFormatter(row, column, cellValue, index) {
      if (1 == cellValue) {
        return "线下支付";
      } else if (2 == cellValue) {
        return "门店";
      }
      return cellValue;
    },
    search() {
      let params = this.getQuery();
      params.shopId = this.shopId;
      params.page = 1;
      let that = this;
      this.$router.replace({ query: params }, null, function () {
        that.$router.go(0);
      });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
  },
};
</script>

<style scoped>
@media screen and (max-device-width: 960px) {
  .search-input {
    width: 105px;
  }
}
@media screen and (min-device-width: 960px) {
  .search-input {
    width: 150px;
  }
}
.search-box span {
  display: inline-block;
  padding: 2px 2px 2px 0px;
}
.search-box span label {
  display: inline-block;
  width: 55px;
}
</style>


// WEBPACK FOOTER //
// List.vue?5bffd832